// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"318":"4e8cc5ff9f063238a72b","669":"35192cd643ddbb6da37f","795":"73280350e9a1ab6864ab","796":"3ab57d1897aca47a0b3c","820":"952f2a43bee29ae20373"}[chunkId] + ".js";
};